var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.417 58.5815V88.109C116.417 103.719 103.717 116.419 88.1064 116.419H38.8939C23.2835 116.419 10.5835 103.719 10.5835 88.109V49.9561H115.041C115.835 52.3373 116.258 54.7715 116.364 57.3644C116.417 57.7348 116.417 58.2111 116.417 58.5815Z",
    fill: "url(#paint0_linear_9640_58)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.041 49.953H10.5835V33.9722C10.5835 21.0605 21.061 10.583 33.9727 10.583H46.3022C54.9277 10.583 57.6264 13.3876 61.066 17.9913L68.4743 27.8338C70.1147 30.0034 70.3264 30.3209 73.3956 30.3209H88.1593C100.701 30.268 111.39 38.523 115.041 49.953Z",
    fill: "#EDBF7A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9640_58",
    x1: 59.7149,
    y1: 61.903,
    x2: 102.048,
    y2: 130.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C78645"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.f16245da72f14625d84e9af5d120731a.svg";
export { ForwardRef as ReactComponent };